import {endpoint} from "@/utils/api/Conf";
import {Path} from "@/types/Paths";
import {RequestError} from "@/types/RequestError";

export const pathRequest = async (pathId: string): Promise<Path | false> => {
  try {
    const init: RequestInit = {
      method: "GET"
    }
    return await fetch(endpoint + `paths/${pathId}`, init)
      .then((response) => response.json())
      .then((data: Path) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
}

export const pathSegmentsRequest = async (authToken: string, pathId: string): Promise<Path | false> => {
  if (!authToken) return false
  try {
    const init: RequestInit = {
      method: "GET",
      headers: {
        'Authorization': `Bearer ${authToken}`,
      }
    }
    return await fetch(endpoint + `paths/${pathId}/segments`, init)
      .then((response) => response.json())
      .then((data: Path) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};

export const abandonPathRequest = async (path_id: string, locale: string, authToken: string): Promise<RequestError | false> => {
  try {
    const init: RequestInit = {
      method: "POST",
      body: JSON.stringify({path_id}),
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${authToken}`,
        "X-Language": locale || "it"
      }
    }
    return await fetch(endpoint + 'walk/abandon', init)
      .then((response) => response.json())
      .then((data: RequestError) => {
        return data
      });
  } catch (error) {
    console.error("An error occurred while fetching data: ", error);
    return false
  }
};
